function MissionVisionSection() {
  return (
    <div className="mt-32 p-4  overflow-x-hidden">

      <div className="flex  w-full md:w-fit lg:w-fit mt-10 flex-col md:flex-col lg:flex-row items-center justify-between md:mx-32 bg-slate-300 dark:bg-[#222A32] p-4 rounded-2xl lg:p-10 " data-aos="fade-left">
        <h2 className="text-[32px] md:text-[40px] font-bold bg-clip-text text-transparent bg-gradient-to-r from-[#0CC8E8] to-[#2DEEAA] text-center leading-[46px]">
          Vision
        </h2>
        <p className=" text-center lg:text-start xl:text-start 2xl:text-start text-[13.7px] md:text-[15px] lg:text-[15px] tracking-lighter md:px-32 dark:text-white">
          Our vision is centered on promoting inclusivity and equitable access
          to comprehensive resources within the speech-language pathology field.
          We are committed to facilitating accurate assessments and offering a
          diverse array of therapeutic exercises that cater to the unique needs
          of every individual. Through our dedication to accessibility, we aim
          to empower clinicians, patients, and caregivers alike, fostering a
          collaborative environment where everyone can thrive and reach their
          full communication potential.
        </p>
      </div>
      <div className="flex w-full md:w-fit lg:w-fit mt-10 flex-col md:flex-col lg:flex-row items-center justify-between md:mx-32 bg-slate-300 dark:bg-[#222A32] p-4 rounded-2xl lg:p-10 " data-aos="fade-left">
        <h2 className="text-[32px] md:text-[40px] font-bold bg-clip-text text-transparent bg-gradient-to-r from-[#0CC8E8] to-[#2DEEAA] text-center leading-[46px]">
          Mission
        </h2>
        <p className=" text-center  text-[13.7px] lg:text-[15px] tracking-lighter md:px-24 dark:text-white">
          Transforming the landscape of assessments and interventions in
          speech-language pathology, IzzyAI is driven by a mission to harness
          the power of artificial intelligence. We tailor our avatars to meet
          the unique needs of each user, ensuring precision and effectiveness in
          every interaction. Through relentless innovation and a focus on
          empowerment, we seek to redefine the standards of personalized care,
          ultimately enhancing communication outcomes for individuals across the
          globe.
        </p>
      </div>
    </div>
  );
}

export default MissionVisionSection;
